import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const ClipboardOutlinedIcon = memo(
  ({ fontSize = 18, color = colors.basic.black, className, style }: SvgIconProps) => (
    <SvgIcon
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      className={className}
      style={{ fontSize, ...style }}
    >
      <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1769_1538)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 3.80457V4.76457C13 5.29476 12.5523 5.72457 12 5.72457H6C5.44772 5.72457 5 5.29476 5 4.76457V3.80457H3C1.89543 3.80457 1 4.66418 1 5.72457V21.0846C1 22.145 1.89543 23.0046 3 23.0046H15C16.1046 23.0046 17 22.145 17 21.0846V5.72457C17 4.66418 16.1046 3.80457 15 3.80457H13Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 1.88452H6C5.44772 1.88452 5 2.31433 5 2.84452V4.76452C5 5.29471 5.44772 5.72452 6 5.72452H12C12.5523 5.72452 13 5.29471 13 4.76452V2.84452C13 2.31433 12.5523 1.88452 12 1.88452Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M9 10.5245H13" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5 10.5245H6" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 14.3645H13" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5 14.3645H9" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M10 18.2045H13" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5 18.2045H7" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
          <clipPath id="clip0_1769_1538">
            <rect width="18" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  ),
);
